module.exports = __webpack_public_path__ + "img/1493734235.ae8934e6.jpg";